import {
  Component,
  ViewEncapsulation,
  ViewChild,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RoutingService } from 'src/app/service/routing.service';
import {
  DrawerType,
  MobileDrawerService,
} from '../shared/sevices/mobile-drawer-service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-mobile-layout',
  templateUrl: './mobile-layout.component.html',
  styleUrls: ['./mobile-layout.component.scss'],
})
export class MobileLayoutComponent implements AfterViewInit, OnDestroy {
  @ViewChild('chatNavDrawer') chatNavDrawer: MatDrawer;
  @ViewChild('userNavDrawer') userNavDrawer: MatDrawer;
  isDrawerOpen = false;
  private destroy$ = new Subject<void>();

  constructor(
    public routing: RoutingService,
    private mobileDrawerService: MobileDrawerService,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mobileDrawerService.drawerState$
        .pipe(takeUntil(this.destroy$))
        .subscribe((state) => {
          if (this.chatNavDrawer) {
            if (state[DrawerType.CHAT]) {
              this.chatNavDrawer.open();
            } else {
              this.chatNavDrawer.close();
            }
          }
          if (this.userNavDrawer) {
            if (state[DrawerType.USER]) {
              this.userNavDrawer.open();
            } else {
              this.userNavDrawer.close();
            }
          }
        });
    });
  }

  ngOnDestroy() {
    this.mobileDrawerService.resetDrawerState();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
